import Image from "next/image"

import { Box } from "components/shared/box"
import { Section } from "components/shared/landing/section"
import { Text } from "components/shared/text"

type AdvantagesSectionProps = {
  title?: string
  higherBottomMargin?: boolean
}

export function AdvantagesSection({
  title = "Why Cryptobots Stand Out",
  higherBottomMargin = false,
}: AdvantagesSectionProps) {
  const blocks = [
    {
      imgSrc: "/images/pages/index/advantages-section/gamepad.svg",
      text: "From the founders of Playneta — a game studio with 100mln+ users.",
      className: "mb-8",
    },
    {
      imgSrc: "/images/pages/index/advantages-section/dollar.svg",
      text: `A sustainable in-game economy based on disruptive innovations in token utility, staking, burn, and
    earnings that allow a much bigger game economy and in-game market.`,
      className: "mb-8",
    },
    {
      imgSrc: "/images/pages/index/advantages-section/mobile.svg",
      text: "Fully playable on mobile via progressive web application + layer 2 solutions to ensure maximum access.",
    },
  ]

  return (
    <Section header={title} className="mt-10" higherBottomMargin={higherBottomMargin}>
      <Box className="max-w-[800px] self-center">
        {blocks.map((item, index) => RenderBlock({ ...item, key: index }))}
      </Box>
    </Section>
  )
}

const RenderBlock = ({
  imgSrc,
  text,
  className,
  key,
}: {
  imgSrc: string
  text: string
  className?: string
  key: number
}) => {
  return (
    <Box row className={["items-center", className].join(" ")} key={key}>
      <Box className="relative h-[45px] min-w-[45px] md:h-[60px] md:min-w-[60px] mr-4 md:mr-8">
        <Image src={imgSrc} alt="icon" layout={"fill"} />
      </Box>
      <Text as="p" className="md:text-h4">
        {text}
      </Text>
    </Box>
  )
}
